import { SUBSCRIPTIONS_DELETE_SUBSCRIPTION } from 'apiRoutes';
import { ConfirmationModal } from 'components/common/ConfirmationModal/ConfirmationModal';
import useSubmit, { POST } from 'hooks/useSubmit';

export const DeleteSubscriptionModal: React.FC<{
	setShowModal: (show: boolean) => void;
	showModal: boolean;
	subscriptionId: number;
	onSubscriptionDeleted: () => void;
}> = ({ setShowModal, showModal, subscriptionId, onSubscriptionDeleted }) => {
	const [deleteSubscription, status] = useSubmit(
		`${SUBSCRIPTIONS_DELETE_SUBSCRIPTION}`,
		POST,
		{
			messageOnError: 'An error occured, please try again!',
			messageOnSuccess: `Subscription deleted successfully`,
			showApiError: true,
		},
	);

	const onDeleteSubscription = async (comment?: string) => {
		const result = await deleteSubscription({
			subscriptionId: subscriptionId,
			comment: comment ?? null,
		});
		if (result.success) {
			onSubscriptionDeleted();
			setShowModal(false);
		}
	};

	return (
		<ConfirmationModal
			showModal={showModal}
			setShowModal={setShowModal}
			onSubmit={onDeleteSubscription}
			header={'Delete Subscription'}
			text={`Are you sure you want to delete this subscription?`}
			buttonText={'Delete Subscription'}
			loadingStatus={status}
		/>
	);
};
